// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-3eA6HAan clearfix","list":"list-btw0f2Pp","black_01":"black_01-2XN8yaT_","word_01":"word_01-3SlpXNF0"};